const UUID_V4_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function randomUuidV4FromBytes(bytes: Uint8Array): string {
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function newAnonymousVoterId(): string {
  try {
    if (typeof globalThis.crypto?.randomUUID === "function") return globalThis.crypto.randomUUID();
    if (typeof globalThis.crypto?.getRandomValues === "function") {
      return randomUuidV4FromBytes(globalThis.crypto.getRandomValues(new Uint8Array(16)));
    }
  } catch {
    // Fall back to a UUID-shaped identifier below; voter identity is intentionally anonymous.
  }
  const bytes = new Uint8Array(16);
  for (let index = 0; index < bytes.length; index += 1) bytes[index] = Math.floor(Math.random() * 256);
  return randomUuidV4FromBytes(bytes);
}

export function getOrCreateAnonymousVoterId(scope: string): string {
  const storageKey = `participant-voter-id:${scope}`;
  try {
    const existing = globalThis.localStorage.getItem(storageKey)?.trim();
    if (existing && UUID_V4_RE.test(existing)) {
      return existing;
    }
    const created = newAnonymousVoterId();
    globalThis.localStorage.setItem(storageKey, created);
    return created;
  } catch {
    return newAnonymousVoterId();
  }
}
